import React, {Component} from "react";
import HttpRequest from "../../../HttpRequest";
import Route, {default as Links} from "../../../Route";
import {Tools} from "../../../Tools";
import Loader from "../../../components/Loader";
import ErrorPage from "../../../components/ErrorPage";
import DataTable from "react-data-table-component";

const
    columns = [
        {
            name: "Civilité",
            selector: function (row) {
                return row['civility']
            },
            sortable: true,
            //right: true,
            allowOverflow: true,
        },
        {
            name: "Nom et prénom",
            selector: function (row) {
                return row['name'] + " " + row['firstName']
            },
            sortable: true,
            allowOverflow: true,
        },
        {
            name: "Email",
            selector: function (row) {
                return row['email']
            },
            sortable: true,
            //right: true,
            allowOverflow: true,
        },
        {
            name: "Phone",
            selector: function (row) {
                return row['phone']
            },
            sortable: true,
            right: true,
            allowOverflow: true,
        },
        {
            name: "Promotion",
            selector: function (row) {
                return row['promotion']
            },
            sortable: true,
            //right: true,
            allowOverflow: true,
        },
        {
            name: "Cycle",
            selector: function (row) {
                return row['cycle']
            },
            sortable: true,
            //right: true,
            allowOverflow: true,
        },
        {
            name: "Cycle terminé",
            selector: function (row) {
                return row['hasFinishedCycle'] ? "OUI" : "NON"
            },
            sortable: true,
            //right: true,
            allowOverflow: true,
        },
        {
            name: "Profession",
            selector: function (row) {
                return row['profession'] && row['profession'].name ? row['profession'].name : "NA"
            },
            sortable: true,
            right: true,
            allowOverflow: true,
        },
    ];
class Members extends Component{
    constructor(props){
        super(props);

        // Binding Handler for external libraries
        this.handleRowClicked = this.handleRowClicked.bind(this);

        this.httpClient = new HttpRequest();
        this.state = {
            server: {},
            isLoadCompleted: false,
            hasPageError: false,
            hasError: false,
            isTableRowLoadCompleted: false,
        };
        this.query = {};
    }


    // Handler for external libraries
    handleRowClicked(item){}

    render() {

        let element = <h3 className="">Liste des membres</h3>
        if(!this.state.isLoadCompleted){
            element = <Loader />;
        }
        else if(this.state.hasError){
            const text = this.state.server && this.state.server.message ? "<h1>"+ this.state.server.message +"</h1>" : "";
            element = <ErrorPage data={{content: text}} />;
        }
        else{
            if(!Tools.IsEmpty(this.state.members)){
                element = (
                    <div className=" admin-font-size">
                        <div className="row">
                            <div className="col-lg-12">
                                <DataTable
                                    title={this.state.members.length + " membre(s) trouvé(s)"}
                                    columns={columns}
                                    data={this.state.members}
                                    pagination
                                    progressPending={!this.state.isTableRowLoadCompleted}
                                    pointerOnHover={true}
                                    striped={true}
                                    highlightOnHover={true}
                                    responsive={true}
                                />
                            </div>
                        </div>
                    </div>
                );
            }
        }

        return element;
    }


    componentDidMount() {
        this.loadMembers();
    }

    componentWillUnmount() {
        this.httpClient.cancelRequest();
    }

    loadMembers() {
        // Call to the API
        const _self = this;
         this.httpClient.request(Route.APIMembers, "GET").then(function (response){
            let data = {server: response, isLoadCompleted: true, hasError: true};
            _self.server = response;
            if(response.code === 200){
                data = {
                    hasError: false,
                    isLoadCompleted: true,
                    isTableRowLoadCompleted: true,
                    members: response.data.members,
                };
            }

            _self.setState(data);
        }).catch(function (error){
             _self.server = error;
             _self.setState({server: error, hasError: true });
        });
    }
}

export default Members;